var render = function () {
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "app-dialer-call-status",
      class: ((_obj = {}), (_obj["is-" + _vm.size] = true), _obj),
    },
    [
      _vm.isInProgress
        ? _c(
            "div",
            { staticClass: "title" },
            [
              _c(
                "or-tooltip",
                { attrs: { content: _vm.message, placement: "bottom" } },
                [_vm._v("\n      " + _vm._s(_vm.duration) + "\n    ")]
              ),
            ],
            1
          )
        : _vm.isConnecting
        ? _c("div", { staticClass: "message" }, [
            _vm._v(
              "\n    " +
                _vm._s(_vm.$t("hitl.modules.dialer.connecting-phone-call")) +
                "\n  "
            ),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }